import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from '../actions';
import {connect} from 'react-redux';

class DownloadReoptimizedLineups extends Component {
    onClick() {
        this.props.dispatch(Action.do('downloadReoptimizedLineups'));
    }

    render() {
        const {className = '', children = null} = this.props;

        return (
            <a className={className} onClick={::this.onClick}>
                {children}
            </a>
        );
    }
}

export default connect(() => ({}))(DownloadReoptimizedLineups);
